module.exports = __webpack_public_path__ + "img/20190528_im.b906fc0c.png";